import React from 'react';
import { FadeIn } from './FadeIn';
export function TruthSection() {
  return <section className="py-16 md:py-24 px-4 bg-white relative" data-id="element-469">
      <div className="max-w-3xl mx-auto" data-id="element-470">
        <FadeIn data-id="element-471">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-green-deep text-center mb-12" data-id="element-472">
            🔬 LA VERDAD QUE NADIE TE DICE EN EL CONSULTORIO
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-473">
          <div className="text-center mb-10" data-id="element-474">
            <p className="font-heading font-bold text-2xl md:text-3xl text-orange-warm leading-tight" data-id="element-475">
              El 70% del sistema inmune de tu hijo no vive en sus pulmones.
            </p>
            <p className="text-lg md:text-xl text-text-main mt-4" data-id="element-476">
              No vive en su garganta.
            </p>
            <p className="font-heading font-bold text-3xl md:text-4xl text-green-deep mt-4" data-id="element-477">
              Vive en su intestino.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-6 text-text-main font-body text-base md:text-lg leading-relaxed" data-id="element-478">
          <FadeIn delay={0.2} data-id="element-479">
            <p data-id="element-480">
              Y mientras vos seguís tratando los síntomas arriba — el moco, la
              fiebre, la tos — la verdadera batalla se está perdiendo abajo, en
              silencio, en la microbiota.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-481">
            <div className="bg-cream p-6 rounded-2xl border border-green-mint/30" data-id="element-482">
              <p className="mb-4" data-id="element-483">
                Cada ciclo de antibióticos elimina entre el{' '}
                <strong data-id="element-484">30% y el 50%</strong> de la diversidad bacteriana
                intestinal.
              </p>
              <p data-id="element-485">
                Esa diversidad tarda entre <strong data-id="element-486">6 meses y 2 años</strong> en
                recuperarse sola.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-487">
            <p data-id="element-488">
              Sin recuperación activa, tu hijo llega al próximo invierno con las
              defensas más débiles que el anterior.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-489">
            <div className="text-center mt-10 p-6 bg-green-deep text-white rounded-2xl shadow-soft" data-id="element-490">
              <p className="font-heading text-2xl md:text-3xl font-bold mb-2" data-id="element-491">
                No es mala suerte. Es biología.
              </p>
              <p className="text-green-mint text-lg md:text-xl" data-id="element-492">
                Y la biología se puede cambiar.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}